export const base_url ="http://localhost:8002/api/"

const customerData = localStorage.getItem("customer");
const storedUser = customerData ? JSON.parse(customerData) : null;

// "http://localhost:80/api/"
// "https://roarz-kreatives-backend.onrender.com/api/"

// Extract token based on the user's login method
const token = storedUser?.token || storedUser?.user?.token;

export const config = {
  headers: {
    Authorization: `Bearer ${token ? token : ""}`,
    Accept: "application/json",
  },
};
